<template>
  <SignatureDialogLayout title="Gerencie seu plano">
    <!-- Plan Cycle -->
    <div class="plan-cycle">
      <button :class="{ selected: cycle === 'MONTHLY' }" @click="handleClickCycle('MONTHLY')">Mensal</button>
      <button :class="{ selected: cycle === 'YEARLY' }" @click="handleClickCycle('YEARLY')">
        Anual <span v-if="selectedPlan?.annual_discount">-R$ {{ selectedPlan.annual_discount }}</span>
      </button>
    </div>

    <SignaturePlans @selected="$emit('selected', $event)" />

    <div class="signature-information">
      Seu plano CheckMotors será renovado automaticamente. É possível cancelar a qualquer momento.<br />
      <a href="#" @click="handleWhatsappClick('Tenho algumas dúvidas quanto aos planos')">Dúvidas? Clique aqui e fale conosco</a>
    </div>

    <template v-if="selectedPlan?.code === 'custom'" #footer>
      <VBtn depressed color="primary" @click="handleWhatsappClick()"><VIcon class="mr-3">mdi-whatsapp</VIcon> FALE CONOSCO</VBtn>
    </template>

    <template v-else #footer>
      <VBtn v-if="canCancel" depressed @click="$emit('close')">Cancelar</VBtn>
      <VBtn depressed color="primary" :disabled="!selectedPlan" @click="$emit('next')">Continuar</VBtn>
    </template>
  </SignatureDialogLayout>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import SignatureDialogLayout from '../SignatureDialogLayout';
import SignaturePlans from '../SignaturePlans';

export default {
  name: 'StepSelectPlan',
  components: { SignatureDialogLayout, SignaturePlans },
  computed: {
    ...mapState('Payment', ['selectedPlan', 'cycle']),
    ...mapState('Auth', ['user']),
    canCancel() {
      const signatures = this.user?.organization?.organization_signatures;
      if (!signatures || signatures.length === 0) return false;
      return signatures.every((s) => s.status === 'ok');
    }
  },
  methods: {
    ...mapActions('Payment', ['setCycle']),
    handleClickCycle(cycle) {
      this.setCycle(cycle);
    },
    handleWhatsappClick(text) {
      const textToSend = text || 'Quero falar sobre um plano personalizado';
      window.open(`whatsapp://send?text=${textToSend}&phone=5565992774481`);
    },
  }
};
</script>
<style lang="scss" scoped>
.plan-cycle {
  button {
    flex: 1 1 0;
  }
}
</style>
